/**
 * Pagination Component
 *
 * Export pagination component and types.
 *
 * @since 1.0.0
 */

export { Pagination } from "./component";
export type { PaginationProps, PaginationStrings } from "./types";
